
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor("Matrix.Workflow.QueueFieldNameEditor")
    export class QueueFieldNameEditor extends Serenity.Select2Editor<Serenity.Select2EditorOptions, any> {

        constructor(element: JQuery, opt: Serenity.Select2EditorOptions) {
            super(element, {
                autoComplete: true
            });

            var fields = ["RowId", "Priority"];
            for (var col of Q.getForm(WorkflowInstanceForm.formKey)) {
                fields.push(col.name);
            }

            fields.sort();
            for (var field of fields)
                this.addOption(field, field);
        }
    }
}   